<template lang="pug">
  ul.mt0.list-reset.sticky-list
    li.mb2.sticky-item(v-for="item, idx in data", :key="item.id")
      .primary-info
        a(:href="item.origin_url", target="_blank")
          .mt0.mb1.item-title(:title="item.title", data-clamp="3") {{ item.title }}
      .primary-img
        a(:href="item.origin_url", target="_blank")
          img.fit(:src="shift(item.o_pic_list[0])")
</template>

<script>
import transformImgLink from '@/assets/utils/transformImgLink'
export default {
  props: ['data'],
  methods: {
    shift (link) {
      return transformImgLink(link)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../assets/variables.styl';
.sticky-list
  .primary-img
    height 0
    overflow hidden
    transition height 1s ease-out
  .sticky-item:hover
    .primary-img
      height 150px
      transition-delay .5s
</style>





// WEBPACK FOOTER //
// StickyList.vue?0bd14f04